import React from 'react';
import Text from 'components/common/Text';
import GlobalLoader from 'components/common/GlobalLoader';
import FireberryIcon from 'images/FireberryIcon.png';
import WhiteBG from 'images/white-bg.png';
import * as S from './style';
import * as Constant from 'constant';

function DesktopCreatingScreen(props) {
  return (
    <S.CreatingScreenContainer bgImg={WhiteBG}>
      <S.ContentContainer>
        <S.LogoContainer>
          <S.Img
            src={FireberryIcon}
            width={'55px'}
            height={'55px'}
            data-testid='successIcon'
          />
        </S.LogoContainer>
        <S.HeadlinesContainer>
          <Text size={Constant.SIZE._5xl} bold dataTestId='header'>
            {props.headline}
          </Text>
          <Text size={Constant.SIZE.xxl} dataTestId='subtext'>
            {props.secondaryHeadline}
          </Text>
        </S.HeadlinesContainer>
        <S.DesktopLoaderContainer>
          <GlobalLoader isLoading value={50} />
        </S.DesktopLoaderContainer>
      </S.ContentContainer>
    </S.CreatingScreenContainer>
  );
}

export default DesktopCreatingScreen;
